import React, { useState, useEffect } from "react";
import "../../../styles/globalStyles.css";
import styles from "./TrainingForAdults.module.css";
import styleFromSQL from "./SQLTraining.module.css";
import { Link, useLocation } from "react-router-dom";
import Seo from "./../../Seo";
import {
  PersonStanding,
  Laptop,
  FolderOpen,
  Globe,
  Search,
  Mail,
  PanelsTopLeft,
  Video,
  ShieldCheck,
  MapPinHouse,
  Keyboard,
  CheckCircle,
  CircleQuestionMark
} from "lucide-react";

const TrainingForAdults = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="/#"]');
      if (target && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, [isMenuOpen]);

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [location]);

  return (
    <>
      <Seo
        title="Cyfrowy Senior – kurs obsługi komputera dla osób 50+"
        description="Praktyczny kurs obsługi komputera i internetu dla osób 50+. Naucz się korzystać z komputera, poczty elektronicznej i usług online w spokojnym tempie."
        canonical="/training/cyfrowy-senior"
      />
      <section id="service" className="sectionContainer light">
        <div className={`${styles.titleTrainingCS} "sectionTitle"`}>
          <h1>Cyfrowy senior - kurs obsługi komputera i internetu</h1>
        </div>

        <header>
          <h2>
            „Najbardziej skąplikowanym komputerem na świecie jest{" "}
            <strong>NASZ MÓZG</strong>.”
          </h2>
        </header>
        <div className={styles.container}>
          {/* 1 */}
          <div className={styles.module}>
            <div className={styles.moduleHeader}>
              <h3 className={styles.headerFH3}>Moduł 1</h3>
              <h4 className={styles.headerH4}>Podstawy obsługi komputera</h4>
            </div>
            <div className={styles.moduleContent}>
              <div className={styles.moduleDescription}>
                <div className={styles.listOfSkills}>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>Komputer i jego podstawowe elementy.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Obsługa myszy, touchpada i klawiatury.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      Pulpit i podstawowe elementy systemu operacyjnego.
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>Otwieranie programów i przełączanie okien.</span>
                  </div>
                </div>
              </div>
              <div className={styles.moduleIcon}>
                <Laptop className={styles.categoryIcon} />
              </div>
            </div>
          </div>

          {/* --------------------------------------------------------------------------------------------- */}

          <div className={styles.module}>
            <div className={styles.moduleHeader}>
              <h3 className={styles.headerFH3}>Moduł 2</h3>
              <h4 className={styles.headerH4}>
                Pliki i foldery czyli porządkowanie dokumentów i zdjęć
              </h4>
            </div>
            <div className={styles.moduleContent}>
              <div className={styles.moduleDescription}>
                <div className={styles.listOfSkills}>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Czym są pliki i foldery.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Tworzenie folderów (np. Dokumenty, Zdjęcia, Pobrane).
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      Zapisywanie plików w odpowiednich lokalizacjach.
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Przenoszenie plików między folderami.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Usuwanie plików i folderów.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Kosz – odzyskiwanie i trwałe usuwanie.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Rozszerzenia plików i ich znaczenie (np. .jpg, .pdf,
                      .docx).
                    </span>
                  </div>
                </div>
              </div>
              <div className={styles.moduleIcon}>
                <FolderOpen className={styles.categoryIcon} />
              </div>
            </div>
          </div>

          {/* --------------------------------------------------------------------------------------------- */}

          <div className={styles.module}>
            <div className={styles.moduleHeader}>
              <h3 className={styles.headerFH3}>Moduł 3</h3>
              <h4 className={styles.headerH4}>Poruszanie się po internecie</h4>
            </div>
            <div className={styles.moduleContent}>
              <div className={styles.moduleDescription}>
                <div className={styles.listOfSkills}>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Co to jest przeglądarka internetowa.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Budowa okna przeglądarki i podstawowe funkcje.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>Zakładki i ulubione strony.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Bezpieczne rozpoznwanie stron internetowych.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>Podstawy korzystania z różnych serwisów.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      Co to jest i jak działa: router, modem, Wi-Fi, hotspot.
                    </span>
                  </div>
                </div>
              </div>
              <div className={styles.moduleIcon}>
                <Globe className={styles.categoryIcon} />
              </div>
            </div>
          </div>
          {/* --------------------------------------------------------------------------------------------- */}

          <div className={styles.module}>
            <div className={styles.moduleHeader}>
              <h3 className={styles.headerFH3}>Moduł 4</h3>
              <h4 className={styles.headerH4}>
                Wyszukiwanie informacji w internecie
              </h4>
            </div>
            <div className={styles.moduleContent}>
              <div className={styles.moduleDescription}>
                <div className={styles.listOfSkills}>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Jak wpisywać zapytania w wyszukiwarce.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Jak korzystać ze sztucznej inteligencji podczas
                      wyszukiwania informacji.
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Ciasteczka (cookies) i uzasadniony interes.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Rozpoznawanie reklam i niepewnych źródeł.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Weryfikacja podstawowych informacji.</span>
                  </div>
                </div>
              </div>
              <div className={styles.moduleIcon}>
                <Search className={styles.categoryIcon} />
              </div>
            </div>
          </div>

          {/* --------------------------------------------------------------------------------------------- */}

          <div className={styles.module}>
            <div className={styles.moduleHeader}>
              <h3 className={styles.headerFH3}>Moduł 5</h3>
              <h4 className={styles.headerH4}>Poczta e-mail</h4>
            </div>
            <div className={styles.moduleContent}>
              <div className={styles.moduleDescription}>
                <div className={styles.listOfSkills}>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>Zakładanie i logowanie do skrzynki e-mail.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Budowa skrzynki e-mail i podstawowe funkcje.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Odbieranie i wysyłanie wiadomości.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Odpowiadanie na e-maile.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Dodawanie i pobieranie załączników (zdjęcia, dokumenty).
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Bezpieczne korzystanie z poczty (spam, phishing).
                    </span>
                  </div>
                </div>
              </div>
              <div className={styles.moduleIcon}>
                <Mail className={styles.categoryIcon} />
              </div>
            </div>
          </div>

          {/* --------------------------------------------------------------------------------------------- */}

          <div className={styles.module}>
            <div className={styles.moduleHeader}>
              <h3 className={styles.headerFH3}>Moduł 6</h3>
              <h4 className={styles.headerH4}>Ważne portale i e-usługi</h4>
            </div>
            <div className={styles.moduleContent}>
              <div className={styles.moduleDescription}>
                <div className={styles.listOfSkills}>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Omówienie portali publicznych (np. ZUS, NFZ, gov.pl).
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Logowanie do usług publicznych.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Pobieranie dokumentów (np. zaświadczeń).</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>Umawianie wizyty online.</span>
                  </div>
                </div>
              </div>
              <div className={styles.moduleIcon}>
                <PanelsTopLeft className={styles.categoryIcon} />
              </div>
            </div>
          </div>

          {/* --------------------------------------------------------------------------------------------- */}

          <div className={styles.module}>
            <div className={styles.moduleHeader}>
              <h3 className={styles.headerFH3}>Moduł 7</h3>
              <h4 className={styles.headerH4}>Spotkania online</h4>
            </div>
            <div className={styles.moduleContent}>
              <div className={styles.moduleDescription}>
                <div className={styles.listOfSkills}>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Co to jest Google Meet, Zoom, Microsoft Teams.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>Dołączanie do spotkania przez link.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>Włączanie i wyłączanie mikrofonu oraz kamery.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Podstawowe elementy interfejsu spotkania online.
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Podstawowe zasady uczestnictwa w wideokonferencji.
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Utworzenie własnego spotkania i zapraszanie innych.
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Problemy występujące podczas spotkań online.</span>
                  </div>
                </div>
              </div>
              <div className={styles.moduleIcon}>
                <Video className={styles.categoryIcon} />
              </div>
            </div>
          </div>

          {/* --------------------------------------------------------------------------------------------- */}

          <div className={styles.module}>
            <div className={styles.moduleHeader}>
              <h3 className={styles.headerFH3}>Moduł 8</h3>
              <h4 className={styles.headerH4}>Bezpieczeństwo w internecie</h4>
            </div>
            <div className={styles.moduleContent}>
              <div className={styles.moduleDescription}>
                <div className={styles.listOfSkills}>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Jak rozpoznawać oszustwa internetowe.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Fałszywe wiadomości i strony logowania.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>Bezpieczne hasła.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Na co uważać przy klikaniu linków i pobieraniu plików.
                    </span>
                  </div>
                </div>
              </div>
              <div className={styles.moduleIcon}>
                <ShieldCheck className={styles.categoryIcon} />
              </div>
            </div>
          </div>

          {/* --------------------------------------------------------------------------------------------- */}

          <div className={styles.module}>
            <div className={styles.moduleHeader}>
              <h3 className={styles.headerFH3}>Moduł 9</h3>
              <h4 className={styles.headerH4}>
                Praktyczne zastosowania (codzienne życie)
              </h4>
            </div>
            <div className={styles.moduleContent}>
              <div className={styles.moduleDescription}>
                <div className={styles.listOfSkills}>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      Mapy i lokalizacja (np. znalezienie apteki, lekarza).
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>Rozkłady jazdy i komunikacja.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>Zakupy online.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Rezerwacje i usługi lokalne.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Oglądanie zdjęć i filmów w internecie.</span>
                  </div>
                </div>
              </div>
              <div className={styles.moduleIcon}>
                <MapPinHouse className={styles.categoryIcon} />
              </div>
            </div>
          </div>

          {/* --------------------------------------------------------------------------------------------- */}

          <div className={styles.module}>
            <div className={styles.moduleHeader}>
              <h3 className={styles.headerFH3}>Moduł 10</h3>
              <h4 className={styles.headerH4}>
                Rozwiązywanie najczęstszych problemów z komputerem.
              </h4>
            </div>
            <div className={styles.moduleContent}>
              <div className={styles.moduleDescription}>
                <div className={styles.listOfSkills}>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      „Najczęstsze problemy i jak je rozwiązać” (np. brak
                      internetu, zamknięcie okna, zawieszenie programu).
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Różnica między ponownym uruchomieniem a wyłączeniem i
                      włączeniem komputera.
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Kilka prostych zasad do zapamiętania podczas korzystania z
                      komputera.
                    </span>
                  </div>
                </div>
              </div>
              <div className={styles.moduleIcon}>
                <CircleQuestionMark className={styles.categoryIcon} />
              </div>
            </div>
          </div>

          {/* --------------------------------------------------------------------------------------------- */}

          <div className={styles.module}>
            <div className={styles.moduleHeader}>
              <h3 className={styles.headerFH3}>Moduł 11</h3>
              <h4 className={styles.headerH4}>Sprawy techniczne</h4>
            </div>
            <div className={styles.moduleContent}>
              <div className={styles.moduleDescription}>
                <div className={styles.listOfSkills}>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      Najważniejsze skróty klawiszowe i ich zastosowanie.
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Najważniejsze skróty związane z systemem Windows.
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Skróty związane z edycją tekstu i przeglądarką
                      internetową.
                    </span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Rola klawiszy funkcyjnych.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span> Rodzaje urządzeń peryferyjnych.</span>
                  </div>
                  <div className={styles.listItemSkill}>
                    <span className={styles.iconSkill}>
                      <PersonStanding />
                    </span>
                    <span>
                      {" "}
                      Najczęściej spotykane złącza w komputerze/laptopie.
                    </span>
                  </div>
                </div>
              </div>
              <div className={styles.moduleIcon}>
                <Keyboard className={styles.categoryIcon} />
              </div>
            </div>
          </div>
        </div>

        <div className={styleFromSQL.conditions}>
          <h3>Co dostajesz w ramach szkolenia:</h3>
          <ul className={styles.listOfConditions}>
            <li>
              <CheckCircle
                className={`${styles.iconCondition} ${styleFromSQL.colorIcon}`}
              />
              Dostosowujemy tempo pracy i sposób prowadzenia zajęć do poziomu
              oraz potrzeb uczestnika.
            </li>
            <li>
              <CheckCircle
                className={`${styles.iconCondition} ${styleFromSQL.colorIcon}`}
              />{" "}
              Nie zostajesz sam z problemami. Pomagamy, odpowiadamy na pytania i
              wspieramy również po zakończeniu kursu.
            </li>
            <li>
              <CheckCircle
                className={`${styles.iconCondition} ${styleFromSQL.colorIcon}`}
              />{" "}
              Otrzymujesz przygotowane materiały, do których możesz wrócić także
              po zakończeniu szkolenia.
            </li>
            <li>
              <CheckCircle
                className={`${styles.iconCondition} ${styleFromSQL.colorIcon}`}
              />{" "}
              Po zakończeniu kursu otrzymujesz potwierdzenie zdobytych
              umiejętnościw formie certyfikatu lub zaświadczenia.
            </li>
            <li>
              <CheckCircle
                className={`${styles.iconCondition} ${styleFromSQL.colorIcon}`}
              />
              Preferujemy pracę na własnym komputerze, ponieważ dzięki temu po
              zakończeniu kursu uczestnik ma gotowe środowisko do dalszej nauki
              i samodzielnej pracy. Na pierwszych zajęciach pomagamy w
              konfiguracji sprzętu. Jeśli nie posiadasz własnego komputera,
              zapewniamy możliwość skorzystania ze sprzętu szkoleniowego.
            </li>
            <li>
              <CheckCircle
                className={`${styles.iconCondition} ${styleFromSQL.colorIcon}`}
              />
              <span style={{ fontWeight: "bold" }}>
                Czas trwania szkolenia: około 25 - 30 godzin
                dydaktycznych.Dokładny czas realizacji zależy od tempa pracy
                uczestników, liczby osób w grupie oraz zakresu omawianego
                materiału.
              </span>
            </li>
          </ul>
        </div>
        <div className={styles.additionInfoAboutContact}>
          <p>
            Jeśli masz pytania dotyczące szkolenia lub nie wiesz, który kurs
            będzie najlepszy, chętnie pomożemy. Skontaktuj się z nami 
            <a href="/#contact" className={styles.contactInfo}>
              telefonicznie, przez formularz kontaktowy lub e-mail.
            </a>{" "}
            Zachęcamy również do odwiedzenia sekcji{" "}
            <a href="/#faq" className={styles.contactInfo}>
              FAQ
            </a>
            , gdzie zebraliśmy odpowiedzi na najczęściej zadawane pytania.
          </p>
        </div>

        <div className={styles.priceSection}>
          <div className={styles.bonus}>
            <div className={styles.promoBanner}>
              <div className={styles.promoContent}>
                <h2 className={styles.user}>
                  Cena dla klientów indywidulanych.
                </h2>
                <h2 className={`${styles.price} ${styles.newPrice}`}>
                  Cena: 650 zł
                </h2>
                <Link to="/#contact" className={styles.ctaButton}>
                  Zapisz się!
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.bonus}>
            <div className={styles.promoBanner}>
              <div className={styles.promoContent}>
                <h2 className={styles.user}>Cena dla grup od 2 do 6 osób.</h2>
                <h2 className={`${styles.price} ${styles.newPrice}`}>
                  Cena: 550 zł
                </h2>
                <Link to="/#contact" className={styles.ctaButton}>
                  Zapisz się!
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.bonus}>
            <div className={styles.promoBanner}>
              <div className={styles.promoContent}>
                <h2 className={styles.user}>Szkolenie dla firm i instytucji</h2>
                <h2 className={`${styles.price} ${styles.newPrice}`}>
                  Cena ustalana jest indywidualnie w zależności od potrzeb
                  firmy.
                </h2>
                <Link to="/#contact" className={styles.ctaButton}>
                  Zapisz się!
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="buttonSection" onClick={() => window.history.back()}>
          <div className="backButtonContainer">
            <button className="backButton">Powrót</button>
          </div>
        </div>
      </section>
    </>
  );
};
export default TrainingForAdults;
